import { Action } from '@reduxjs/toolkit';
import { concat, from, Observable, of, throwError } from 'rxjs';
import { filter, mergeMap, catchError } from 'rxjs/operators';
import { NewsApi } from 'core/api/list';
import { actions } from '../slice';

export const listEpic = (action$: Observable<Action>) =>
  action$.pipe(
    filter(actions.list.match),
    mergeMap(() =>
      from(new NewsApi().list()).pipe(
        mergeMap((result) =>
          concat(of(actions.listSuccess(result)), of(actions.resetStatus())),
        ),
        catchError((error) =>
          concat(
            of(actions.listFailure()),
            of(actions.resetStatus()),
            throwError(error),
          ),
        ),
      ),
    ),
  );
